import navigator from './entry.vue'

navigator.install = function (Vue) {
  Vue.component(navigator.name, navigator)
}

export default navigator


// WEBPACK FOOTER //
// ./src/components/navigator/index.js